<div class="select-placeholder-container">
    <span></span>
    <mat-spinner class="spinner" diameter="20"></mat-spinner>
</div>